class LoginTimerService {
  constructor() {
    this.TIMER_KEY = 'parkking_internal_login_timer';
    this.MAX_DURATION = 60 * 60 * 1000; // 1 hour in milliseconds
  }

  /**
   * Set the login timer for internal users
   */
  setLoginTimer() {
    const loginTime = Date.now();
    localStorage.setItem(this.TIMER_KEY, loginTime.toString());
    //console.log('LoginTimerService: Timer set for internal user at', new Date(loginTime));
  }

  /**
   * Check if the login timer has expired
   * @returns {boolean} true if expired, false if still valid
   */
  isLoginExpired() {
    const loginTime = localStorage.getItem(this.TIMER_KEY);
    
    //console.log('LoginTimerService: isLoginExpired - loginTime from localStorage:', loginTime);
    
    if (!loginTime) {
      // No timer set, consider as expired
      //console.log('LoginTimerService: No timer set, considering as expired');
      return true;
    }

    const currentTime = Date.now();
    const elapsedTime = currentTime - parseInt(loginTime);
    
    //console.log('LoginTimerService: Checking timer - elapsed time:', Math.round(elapsedTime / 1000 / 60), 'minutes');
    //console.log('LoginTimerService: MAX_DURATION:', Math.round(this.MAX_DURATION / 1000 / 60), 'minutes');
    
    return elapsedTime > this.MAX_DURATION;
  }

  /**
   * Get remaining time in milliseconds
   * @returns {number} remaining time in milliseconds, 0 if expired
   */
  getRemainingTime() {
    const loginTime = localStorage.getItem(this.TIMER_KEY);
    
    if (!loginTime) {
      return 0;
    }

    const currentTime = Date.now();
    const elapsedTime = currentTime - parseInt(loginTime);
    const remainingTime = this.MAX_DURATION - elapsedTime;
    
    return Math.max(0, remainingTime);
  }

  /**
   * Get remaining time in a human-readable format
   * @returns {string} remaining time as "MM:SS" format
   */
  getRemainingTimeFormatted() {
    const remainingMs = this.getRemainingTime();
    const minutes = Math.floor(remainingMs / 60000);
    const seconds = Math.floor((remainingMs % 60000) / 1000);
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  /**
   * Clear the login timer
   */
  clearLoginTimer() {
    localStorage.removeItem(this.TIMER_KEY);
    //console.log('LoginTimerService: Timer cleared');
  }

  /**
   * Check if user is internal user
   * @returns {boolean} true if internal user
   */
  isInternalUser() {
    return localStorage.getItem('parkkingusertype') === 'INTERNAL';
  }

  /**
   * Force logout by redirecting to logout page
   */
  forceLogout() {
    //console.log('LoginTimerService: Session expired, forcing logout');
    
    // Check if we're currently on a login-related page
    const currentUrl = window.location.href;
    const isLoginPage = currentUrl.includes('login') || currentUrl.includes('internal') || currentUrl.includes('azure') || currentUrl.includes('handlelogin');
    
    if (isLoginPage) {
      //console.log('LoginTimerService: On login page, not forcing logout');
      return;
    }
    
    // Clear authentication data to trigger cross-tab logout
    localStorage.removeItem('parkkingusertype');
    localStorage.removeItem('parkkingtoken');
    
    window.location.href = '/logout';
  }

  /**
   * Check timer and logout if expired
   * @returns {boolean} true if logged out, false if still valid
   */
  checkAndLogoutIfExpired() {
    //console.log('LoginTimerService: checkAndLogoutIfExpired called');
    //console.log('LoginTimerService: isInternalUser =', this.isInternalUser());
    //console.log('LoginTimerService: isLoginExpired =', this.isLoginExpired());
    
    if (this.isInternalUser() && this.isLoginExpired()) {
      //console.log('LoginTimerService: Timer expired, forcing logout');
      this.forceLogout();
      return true;
    }
    return false;
  }
}

export default new LoginTimerService(); 